import type {ReactElement} from 'react';
import type {EmailMakerControl, EmailMakerControlProps} from '../right-panel-registry.types';

type DescriptorControlInner<D> = (props: EmailMakerControlProps & {descriptor: D}) => ReactElement | null;

/** Closes over `descriptor` and renders `Inner` with it — the shared wrapper for every parameterised control. */
export function createDescriptorControl<D>(Inner: DescriptorControlInner<D>, descriptor: D): EmailMakerControl {
  return function DescriptorControl(props: EmailMakerControlProps): ReactElement | null {
    return <Inner {...props} descriptor={descriptor} />;
  };
}
